<div class="widget__wrap">
  <div class="widget" id="seo-widget" style="position: relative;">
    <h2 class="widget__header">
      <span class="widget__header__title">
        <i class="widget__header__icon ico-angle-down"></i> Profilový obrázek</span>
    </h2>
    <div class="widget__content" *ngIf="isInitialized">
      <form [formGroup]="form" (ngSubmit)="save()" [method]="'post'" *ngIf="isInitialized">
        <swb-form-fields [fields]="FormEditors" [form]="form"></swb-form-fields>
        <div class="align-right">
          <button type="submit" class="cta cta--blue submit" [ngClass]="{'submit--submitting': isSaving}" [disabled]="isSaving">
            <i class="ico-save"></i> Uložit</button>
        </div>
      </form>
      <div *ngIf="!isInitialized" class="loading loading--padding loading--white"></div>
    </div>
  </div>